import { Component, Inject, OnInit, NgZone } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent implements OnInit {
  message: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string, 
    private dialogRef: MatDialogRef<ErrorDialogComponent>,
    private zone: NgZone
  ) { 
    this.message = this.data["message"];
  }

  ngOnInit() {}

  close() {
    this.zone.run(() => {
      this.dialogRef.close();
    })
  }
}
